module.exports = __webpack_public_path__ + "img/msg_img3.4eb7cad5.jpg";